(() => {
  const script = document.querySelector('script[data-tjs-quick-edit-key]');
  if (!script) return;

  const quickEditParam = new URLSearchParams(window.location.search).get('quick-edit');
  const storageKey = 'tjs-quick-edit-enabled';

  if (quickEditParam === 'off') {
    window.localStorage.removeItem(storageKey);
    return;
  }

  if (quickEditParam && quickEditParam === script.dataset.tjsQuickEditKey) {
    window.localStorage.setItem(storageKey, 'true');
  }

  if (window.localStorage.getItem(storageKey) !== 'true') return;

  const store = script.dataset.tjsQuickEditStore;
  if (!store) return;

  const addQuickEditLinks = (root = document) => {
    const containers = [];

    if (root instanceof Element && root.matches('[data-tjs-quick-edit-product-id]')) {
      containers.push(root);
    }

    if (root.querySelectorAll) {
      containers.push(...root.querySelectorAll('[data-tjs-quick-edit-product-id]'));
    }

    containers.forEach((container) => {
      if (container.dataset.tjsQuickEditReady === 'true') return;

      const productId = container.dataset.tjsQuickEditProductId;
      if (!productId) return;

      const link = document.createElement('a');
      link.className = 'tjs-quick-edit__link';
      link.href = `https://admin.shopify.com/store/${encodeURIComponent(store)}/products/${encodeURIComponent(productId)}`;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Edit';

      container.replaceChildren(link);
      container.dataset.tjsQuickEditReady = 'true';
    });
  };

  addQuickEditLinks();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) addQuickEditLinks(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
